import { Configuration as BaseConfig } from '../../shared/configuration/shared.config';

export let Configuration = {

    adminApiUrl: BaseConfig.adminApiUrl,
    apiUrl: BaseConfig.apiUrl,
    dashboardURL: BaseConfig.dashboardURL,

    urls: {
        get: (type: string) => `api/v1/${type}/admin/list`,
        getForOperation: (type: string) => `api/v1/${type}/admin/list`,
        getById: (type: string) => `api/v1/${type}/admin`,
        update: (type: string) => `api/v1/${type}/admin`,
        approve: 'api/v1/project/admin',
        verifyReview: 'api/v1/project/admin/review/verify',
        delete: (type: string) => `api/v1/${type}/admin`,
        permanentDelete: (type: string) => `api/v1/${type}/admin/remove`,
        changeState: 'api/v1/project/admin/state',
        partnerOffer: (projectId, partnerId) => `api/v1/offer/admin/${projectId}/partner/${partnerId}`,
        getAllOffers: 'api/v1/offer/admin',
        comments: 'api/v1/project/admin/comment',
        upload: 'api/v1/upload',
        sendGridLists: 'api/v1/notification/sendgrid/lists',
        sendGridSenders: 'api/v1/notification/sendgrid/senders',
        sendGridCampaign: 'api/v1/notification/sendgrid/campaigns',
        rejectAlternatives: (projectId, offerId) => `api/v1/offer/admin/alternative/${projectId}/reject/${offerId}`,
        approveAlternative: (projectId, offerId) => `api/v1/offer/admin/alternative/${projectId}/approve/${offerId}`,
        rejectAlter: (alterType, projectId, offerId) => `api/v1/offer/customer/${alterType}/${projectId}/reject/${offerId}`,
        approveAlter: (alterType, projectId, offerId) => `api/v1/offer/customer/${alterType}/${projectId}/approve/${offerId}`,
        unRejectAlter: (alterType, projectId, offerId) => `api/v1/offer/customer/${alterType}/${projectId}/unreject/${offerId}`,
        unApproveAlter: (alterType, projectId, offerId) => `api/v1/offer/customer/${alterType}/${projectId}/unapprove/${offerId}`,
        unlockSupplier: projectId => `api/v1/project/admin/${projectId}/unlock/partner`,
        resentInvitation: projectId => `api/v1/project/admin/${projectId}/resend-invitation`,
        exportedOffersLog: 'api/v1/offer/exported/files',
        question: {
          get: 'api/v1/project/question/admin/all',
          update: 'api/v1/project/question',
          delete: 'api/v1/project/question',
          remove: 'api/v1/project/question/remove'
        },
        getInvitedPartners: 'api/v1/project/admin/invited-partners',
        getAdminName: 'api/v1/admin/list/names',
        searchUsers: 'api/v1/user/search/all',
        addPotentialPartners: 'api/v1/project/admin/network/invitations',
        getPartnersBySubCategory: 'api/v1/partner/filter/subCategories',
        removeAccessedPartner: (projectId, partnerId) => `api/v1/project/admin/${projectId}/accessed-partner/${partnerId}`,
        getPartnerProjects: partnerId => `api/v1/project/admin/list/${partnerId}/operation`,
        getCustomers: () => `api/v1/customer/admin/all/active/names`,
        getProjectPartnerStatistics: id => `api/v1/project/admin/${id}/operation/partner-statistics`,
    }
};
